import React from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";
import {TextBold14, ThirtyText} from "@/app/components/texts";
import UserAvatar from "@/app/components/user_avatar/widget";
import {t} from "i18next";
import {s} from "@/app/utils/s";
import Checkbox from "@/app/components/checkbox";
import {NearbyUsersModel, NewSmallUserModel} from "@/app/api/user";
import ReadyToPlay from "@/app/components/ready_to_play/widget";

interface Props {
  user: NearbyUsersModel | NewSmallUserModel;
  className?: string;
  state?: any;
  toggleUser?: (id: number) => void;
  onClick: (user: NearbyUsersModel | NewSmallUserModel) => void;
  isDesktop?: boolean
  userSmallUserName?: boolean
}

const UserRowWidget: React.FC<Props> = ({
                                          user,
                                          state,
                                          toggleUser,
                                          onClick,
                                          isDesktop = false,
                                          userSmallUserName = false
                                        }) => (
  <div className={classNames(styles.user, {[styles.desktop]: isDesktop})} onClick={() => onClick(user)}>
    <div className={styles.avatar}>
      <UserAvatar userAvatar={user.imageLink} userName={user.username ?? ""}/>
    </div>
    <div className={styles.info}>
      <div className={styles.nameAndMatches}>
        <ThirtyText text={user.username} className={classNames(styles.name, {[styles.small]: userSmallUserName})}/>
        {user.matchesCount && user.matchesCount > 0 ?
          <TextBold14 text={t(s.matchesInApp, {matches: user.matchesCount ?? 0})} className={styles.matches}/> : null}
        {isDesktop && <ReadyToPlay/>}
      </div>
      {toggleUser && state.selectSeveral &&
          <div onClick={(e) => e.stopPropagation()} onPointerDown={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
            <Checkbox<number> items={[user.id]} onChange={toggleUser} useS={false} className={styles.checkbox}
                              onlyBox value={state.selectedUsers}/>
          </div>}
    </div>
  </div>
);

export default UserRowWidget;